import React, { useEffect, useState } from 'react';
import { HERITAGE_ASSETS, api } from '@/lib/api';
import { Panel, SectionDivider } from '@/components/Panel';
import { HeritageSeal } from '@/components/BrandMark';

export default function AboutPage() {
 const [content, setContent] = useState({});
 useEffect(() => { (async () => { try { const { data } = await api.get('/site-content'); setContent(data.content || {}); } catch (err) { console.warn('[AboutPage] site-content fetch failed', err); } })(); }, []);

 return (
 <div className="max-w-6xl mx-auto px-6 py-14">
 <div className="text-center">
 <HeritageSeal size={92} />
 <div className="h-eyebrow mt-6">Our Story</div>
 <h1 className="h-display text-5xl md:text-6xl mt-2" style={{ color: 'var(--heritage-plum)' }}>A dahlia field label</h1>
 </div>

 <SectionDivider label="Heritage" />

 <div className="grid md:grid-cols-2 gap-10 items-center">
 <Panel className="p-3">
 <img src={HERITAGE_ASSETS.tracksuitField} alt="Heritage founders" className="w-full h-[520px] object-cover rounded-lg" />
 </Panel>
 <div>
 <div className="h-eyebrow mb-3">Grown in Aotearoa</div>
 <div className="h-serif text-4xl mb-4" style={{ color: 'var(--heritage-plum)' }}>From the flower field to the atelier.</div>
 <p className="text-base leading-relaxed opacity-85" style={{ color: 'var(--heritage-plum)' }}>
 {content.about_body || 'Heritage Apparel began in a dahlia field in New Zealand. What started as a love for flowers grew into a love for craftsmanship. the same slow, seasonal attention we give our flowers, we now give our garments. We do not chase trends. We plant them.'}
 </p>
 <p className="text-base leading-relaxed opacity-85 mt-4" style={{ color: 'var(--heritage-plum)' }}>
 Every piece we release is small-batch, numbered, and finished by hand. Colours are chosen from the field, then translated to yarn. Nothing is ever restocked; when a run is finished, it becomes archive.
 </p>
 </div>
 </div>

 <SectionDivider label="Values" />

 <div className="grid md:grid-cols-3 gap-6">
 {[
 { title: 'Small batches', body: 'We produce in editions of hundreds. never thousands.' },
 { title: 'Slow craftsmanship', body: 'Hand embroidery, hand finishing, hand-signed tags.' },
 { title: 'Community first', body: 'Members shape the collection through the Founders Club.' },
 ].map((v) => (
 <Panel key={v.title} className="p-8">
 <div className="h-serif text-2xl" style={{ color: 'var(--heritage-plum)' }}>{v.title}</div>
 <div className="text-sm mt-2 opacity-85" style={{ color: 'var(--heritage-plum)' }}>{v.body}</div>
 </Panel>
 ))}
 </div>
 </div>
 );
}
